import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";
import { Scan } from "types/scan";
export const useGetScanQuery = (scanId: string) => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["scan", scanId],
    queryFn: async () => {
      const { data } = await authApi.get<Scan>(`/scan/${scanId}`);
      return data;
    },
  });

  return result;
};
